import type { SchemaPath } from '@angular/forms/signals';
import { validate } from '@angular/forms/signals';

const ALPHANUMERIC_WITH_SPACES = /^[a-zA-Z0-9 ]*$/;

/**
 * Schema fragment that fails when a string field contains characters other than
 * letters (a-z, A-Z), digits (0-9), or spaces.
 *
 * Reports a `{ kind: 'notAlphanumeric' }` validation error on failure.
 * Skips validation when the field is empty — pair with `required` to catch
 * the empty case.
 *
 * @param path The schema path of the string field to validate.
 * @example
 * form(model, (p) => {
 *   required(p.name);
 *   minLength(p.name, 2);
 *   alphanumericValidator(p.name);
 * });
 */
export function alphanumericValidator(path: SchemaPath<string>): void {
  validate(path, (ctx) => {
    const v = ctx.value();
    if (typeof v !== 'string' || v.length === 0) {
      return null;
    }
    return ALPHANUMERIC_WITH_SPACES.test(v)
      ? null
      : { kind: 'notAlphanumeric' };
  });
}
